import React from "react";

const Icon = () => {
  return (
    <div>
      <img
        src={`${process.env.PUBLIC_URL}/logo_sutton_encore.webp`}
        width="120"
        height="80"
        alt="icon"
      />
    </div>
  );
};

export default Icon;
